import React, { useState } from "react";
import {
  MyMessage,
  InputField,
  Select,
  AddPageShell,
  AddSection,
} from "../../components/Component";
import { useDoSeeDataContext } from "../../../context/DoSeeDataContext";
import { getOneFood } from "../../../lib/sysNavigation/SysNavigation";
import { FOLDERS, image_kit_folder } from "../utils/Utils";
import { defaultImage } from "../../../lib/libraries/imageKit/ImageKit";
import { ImageKitUpload } from "../../../ui/ImageKitLibrary";
import { useGeoPositionContext } from "../utils/geoPosition";
import { _TYPES_ } from "../utils/types";
import Pricing from "../../components/Pricing";
import GenerateDescription from "../utils/GenerateDescription";
import {
  ContactSection,
  SocialSection,
  GeoSection,
  VisibilitySection,
  DescriptionSection,
} from "../utils/AddSections";
import { FiImage, FiDollarSign } from "react-icons/fi";
import { FaUtensils } from "react-icons/fa";

const Edit = () => {
  const { updateOneContent } = useDoSeeDataContext();
  const food: any = getOneFood();
  const {
    country_id,
    entry_label,
    country_name,
    first_level_id,
    fourth_level_id,
    second_level_id,
    third_level_id,
  } = useGeoPositionContext();

  const [error, setError] = useState<any>(false);
  const [message, setErrorMessage] = useState<any>("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState<any>(false);

  const food_id = food?.food_id;
  const [title, setTitle] = useState<any>(food?.title);
  const [thumbnail, setThumbnail] = useState<any>(food?.thumbnail);
  const [thumbnailId, setThumbnailId] = useState<any>(food?.image_cdn_id);
  const [email, setEmail] = useState<any>(food?.email_address);
  const [payLink, setPayLink] = useState<any>(food?.pay_link);
  const [phoneNumber, setPhoneNumber] = useState<any>(food?.phone_number);
  const [whatsapp, setWhatsapp] = useState<any>(food?.whatsapp);
  const [facebook, setFacebook] = useState<any>(food?.facebook);
  const [twitter, setTwitter] = useState<any>(food?.twitter);
  const [instagram, setInstagram] = useState<any>(food?.instagram);
  const [youtube, setYoutube] = useState<any>(food?.youtube);
  const [hashtags, setHashtags] = useState<any>(food?.hashtag);
  const [googleMapCode, setGoogleMapCode] = useState<any>(food?.google_map_code);
  const [latitude, setLatitude] = useState<any>(food?.latitude);
  const [longitude, setLongitude] = useState<any>(food?.longitude);
  const [formattedAddress, setFormattedAddress] = useState<any>(
    food?.formatted_address
  );
  const [featured, setFeatured] = useState<any>(food?.featured);
  const [promoted, setPromoted] = useState<any>(
    food?.promoted ? food?.promoted : "no"
  );
  const [foodStatus, setFoodStatus] = useState<any>(food?.status);
  const [category, setCategory] = useState<any>(food?.category || "african");
  const [nationality, setNationality] = useState<any>(food?.nationality);
  const [description, setDescription] = useState<any>(food?.description);
  const [expo, setExpo] = useState<any>(food?.expo);
  const [pricing, setPricing] = useState<any>(food?.Pricings);
  const [showDescriptionModal, setShowDescriptionModal] = useState<any>(null);

  const foodRoutes = "/data/food";

  const responses = (isError: any, message: any) => {
    setError(isError);
    setLoading(false);
    setSuccess(!isError);
    setErrorMessage(message);
  };

  const updateOneFoodHandler = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailId) {
      responses(true, "Image Required");
    } else {
      await sendDBRequest();
    }
  };

  const sendDBRequest = async () => {
    const data = {
      country_id: country_id ? country_id : food?.country_id,
      first_level_id: first_level_id ? first_level_id : 0,
      second_level_id: second_level_id ? second_level_id : 0,
      third_level_id: third_level_id ? third_level_id : 0,
      fourth_level_id: fourth_level_id ? fourth_level_id : 0,
      title: title,
      slug: title ? title.toLowerCase().replace(/\s/g, "_") : null,
      description: description,
      thumbnail: thumbnail ? thumbnail : defaultImage,
      image_cdn_id: thumbnailId ? thumbnailId : "",
      phone_number: phoneNumber,
      email_address: email,
      pay_link: payLink,
      whatsapp: whatsapp,
      facebook: facebook,
      twitter: twitter,
      instagram: instagram,
      youtube: youtube,
      hashtag: hashtags,
      audio_adv: "none",
      google_map_code: googleMapCode,
      latitude: latitude,
      longitude: longitude,
      formatted_address: formattedAddress,
      country_short: "none",
      status: foodStatus,
      featured: featured,
      promoted: promoted,
      category: category,
      nationality: nationality ? nationality.toLowerCase() : null,
      expo: expo,
      pricing: pricing,
    };

    const { message, status } = await updateOneContent({
      data_id: food_id,
      data: data,
      content: _TYPES_.FOOD,
      position: {
        country_id,
        first_level_id,
        second_level_id,
        third_level_id,
        fourth_level_id,
      },
    });

    if (status === 200) responses(false, message);
    else responses(true, message);
  };

  const clearMessages = () => {
    setError(null as any);
    setSuccess(null as any);
  };

  return (
    <AddPageShell
      backRoute={foodRoutes}
      eyebrow="DoSee Data • Foods"
      title="Edit Food"
      subtitle={`Update a dish or cuisine showcase from ${entry_label || "this destination"}.`}
      icon={<FaUtensils className="h-5 w-5" />}
      modals={
        showDescriptionModal ? (
          <GenerateDescription
            setDescription={setDescription}
            setShowDescriptionModal={setShowDescriptionModal}
          />
        ) : null
      }
      loading={loading}
      submitLabel="Save Changes"
      onSubmit={updateOneFoodHandler}
      onSubmitClick={() => {
        setError(false);
        setSuccess(false);
        setErrorMessage(null);
      }}
      message={
        <MyMessage
          error={error}
          message={message}
          success={success}
          onExpired={() => {
            setError(false);
            setSuccess(false);
          }}
          onClick={() => {
            setError(false);
            setSuccess(false);
            setErrorMessage("");
          }}
        />
      }
    >
      <AddSection
        title="Cover Image"
        hint="A high-quality plated dish photo."
        icon={<FiImage className="h-4 w-4" />}
      >
        <ImageKitUpload
          thumbnail={thumbnail}
          thumbnailId={thumbnailId}
          setThumbnail={setThumbnail}
          setThumbnailId={setThumbnailId}
          folder={image_kit_folder(country_name, FOLDERS.FOODS)}
        />
      </AddSection>

      <AddSection title="Food Details" hint="Title, cuisine and origin.">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
          <InputField
            props={{
              id: "title",
              title: "Title",
              type: "text",
              required: true,
              value: title || "",
              onChange: (e: any) => {
                setTitle(e.target.value);
                clearMessages();
              },
            }}
          />
          <Select
            props={{
              id: "food_category",
              title: "Food Category",
              option: ["african", "american", "asian", "european", "oceanian"],
              preselect:
                category !== undefined && category !== null
                  ? [{ name: category }]
                  : null,
              onChange: (e: any) => {
                setCategory(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "nationality",
              title: "Nationality (e.g. ugandan)",
              type: "text",
              value: nationality || "",
              onChange: (e: any) => {
                setNationality(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "formatted_address",
              title: "Formatted Address",
              type: "address",
              value: formattedAddress || "",
              onChange: (e: any) => {
                setFormattedAddress(e.target.value);
                clearMessages();
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Pricing"
        hint="Optional pricing tiers."
        icon={<FiDollarSign className="h-4 w-4" />}
      >
        <Pricing pricing={pricing} setPricing={setPricing} />
      </AddSection>

      <ContactSection
        phone={phoneNumber}
        setPhone={setPhoneNumber}
        email={email}
        setEmail={setEmail}
        payLink={payLink}
        setPayLink={setPayLink}
        clearMessages={clearMessages}
      />

      <SocialSection
        whatsapp={whatsapp}
        setWhatsapp={setWhatsapp}
        facebook={facebook}
        setFacebook={setFacebook}
        twitter={twitter}
        setTwitter={setTwitter}
        instagram={instagram}
        setInstagram={setInstagram}
        youtube={youtube}
        setYoutube={setYoutube}
        clearMessages={clearMessages}
      />

      <GeoSection
        googleMapCode={googleMapCode}
        setGoogleMapCode={setGoogleMapCode}
        latitude={latitude}
        setLatitude={setLatitude}
        longitude={longitude}
        setLongitude={setLongitude}
        clearMessages={clearMessages}
      />

      <VisibilitySection
        statusId="food_status"
        setStatus={setFoodStatus}
        setFeatured={setFeatured}
        setPromoted={setPromoted}
        setExpo={setExpo}
        status={foodStatus}
        featured={featured}
        promoted={promoted}
        expo={expo}
        clearMessages={clearMessages}
      />

      <DescriptionSection
        description={description}
        setDescription={setDescription}
        hashtags={hashtags}
        setHashtags={setHashtags}
        onGenerate={() => setShowDescriptionModal(true)}
        clearMessages={clearMessages}
      />
    </AddPageShell>
  );
};

export default Edit;
